import { html } from '@design.estate/dees-element';
import type { DeesMosaic } from './dees-mosaic.js';
import type { IMosaicLayout } from './types.js';
import { createMosaicLeaf, mosaicInsert } from './tree.js';

const buildDefaultLayout = (): IMosaicLayout => {
  let layout = mosaicInsert({ root: null }, null, 'right', createMosaicLeaf('editor', 'leaf-editor'));
  layout = mosaicInsert(layout, 'leaf-editor', 'right', createMosaicLeaf('chat', 'leaf-chat'));
  layout = mosaicInsert(layout, null, 'bottom', createMosaicLeaf('terminal', 'leaf-terminal'));
  return layout;
};

const surfaceMeta = {
  editor: { title: 'Editor', icon: 'lucide:Code' },
  chat: { title: 'AI Chat', icon: 'lucide:BotMessageSquare' },
  terminal: { title: 'Terminal', icon: 'lucide:SquareTerminal' },
  browser: { title: 'Browser', icon: 'lucide:Globe' },
};

let tileCounter = 0;

const addBrowserTile = (event: MouseEvent) => {
  const mosaic = (event.target as HTMLElement).closest('.mosaicDemo')?.querySelector('dees-mosaic') as DeesMosaic | null;
  if (!mosaic) return;
  tileCounter += 1;
  const leaf = createMosaicLeaf('browser', `leaf-browser-${tileCounter}`);
  mosaic.layout = mosaicInsert(mosaic.layout, 'leaf-chat', 'bottom', leaf);
};

export const demoFunc = () => html`
  <style>
    .mosaicDemo {
      display: grid;
      grid-template-rows: auto minmax(0, 1fr);
      gap: 12px;
      height: 640px;
      max-width: 1000px;
      margin: 40px auto;
    }
    .mosaicDemo .surfaceBody {
      display: grid;
      place-content: center;
      gap: 6px;
      height: 100%;
      text-align: center;
      color: var(--dees-color-text-secondary);
      font-size: 12px;
      background: var(--dees-color-bg-primary);
    }
    .mosaicDemo .surfaceBody strong {
      color: var(--dees-color-text-primary);
      font-size: 14px;
    }
    .mosaicDemo .emptyHint {
      color: var(--dees-color-text-secondary);
      font-size: 13px;
    }
  </style>
  <div
    class="mosaicDemo"
    @mosaic-layout-change=${(event: CustomEvent) => {
      const mosaic = (event.target as HTMLElement);
      (mosaic as DeesMosaic).layout = event.detail.layout;
      console.log('mosaic-layout-change', event.detail.reason, event.detail.layout);
    }}
    @mosaic-tile-close=${(event: CustomEvent) => console.log('mosaic-tile-close', event.detail)}
    @mosaic-tile-focus=${(event: CustomEvent) => {
      ((event.target as HTMLElement) as DeesMosaic).focusedLeafId = event.detail.leafId;
    }}
  >
    <div>
      <dees-button @clicked=${addBrowserTile}>Add browser tile below chat</dees-button>
    </div>
    <dees-mosaic
      .layout=${buildDefaultLayout()}
      .surfaces=${surfaceMeta}
      focusedLeafId="leaf-editor"
    >
      <div slot="tile-leaf-editor" class="surfaceBody"><strong>Editor</strong><span>drag my tilebar; resize the shared edges</span></div>
      <div slot="tile-leaf-chat" class="surfaceBody"><strong>AI Chat</strong><span>docked right</span></div>
      <div slot="tile-leaf-terminal" class="surfaceBody"><strong>Terminal</strong><span>stacked from below</span></div>
      <div slot="tile-leaf-browser-1" class="surfaceBody"><strong>Browser 1</strong></div>
      <div slot="tile-leaf-browser-2" class="surfaceBody"><strong>Browser 2</strong></div>
      <div slot="empty" class="emptyHint">Workspace is empty — add a tile.</div>
    </dees-mosaic>
  </div>
`;
